import { LoadableAfterPaint } from '@confluence/loadable';

import { EditorPageCoverPicturePlaceholder } from './EditorCoverPicture/EditorPageCoverPicturePlaceholder';
import type { EditorPageCoverPictureComponentProps } from './pageCoverPictureTypes';

export const LazyEditorPageCoverPicture = LoadableAfterPaint<EditorPageCoverPictureComponentProps>({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-EditorCoverPictureEditorPageCoverPicture" */ './EditorCoverPicture/EditorPageCoverPicture'
			)
		).EditorPageCoverPicture;
	},
	loading: EditorPageCoverPicturePlaceholder,
});
